import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

export class ShipmentService {

    id: string;
    shipment_id: string;
    external_reference: string;
    service_code: string;
    service_name:  string;

    static _JSONProps: string[] = [
        'id',
        'shipment_id',
        'external_reference',
        'service_code',
        'service_name'
    ];

    constructor(initializer?: ShipmentServiceInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: ShipmentServiceInterface | string): ShipmentService {
        if (json === null) {
            return new ShipmentService();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, ShipmentService.reviver);
        } else {
            let task = Object.create(ShipmentService.prototype);

            let extra = {
            };

            Object.keys(json).forEach((key, index) => {
                if (ShipmentService._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? ShipmentService.fromJSON(value) : value;
    }

    public formattedDate(field: string, format: string) {
        if (this[field]) {
            let thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface ShipmentServiceInterface extends ShipmentService {
}
